/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Credit_Apply_LabelInputs */

const vi_order_credit_apply_label = /** @type {(inputs: Order_Credit_Apply_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trừ vào số dư khách`)
};

/**

* @param {Order_Credit_Apply_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_credit_apply_label = /** @type {((inputs?: Order_Credit_Apply_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Credit_Apply_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_credit_apply_label(inputs)
});